export default __webpack_public_path__ + "static/media/upload.4af19480.svg";